import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./index.css";
import App from "./App";
import { getTheme } from "./misc/theme";
import { GlobalContext } from "./context/Context";
import { VALID_PATHS } from "appConfig";
import { getFaqMap } from "misc/faq_util";

// DETECT INCORRECT ENGINE URLS
const start_path = window.location.pathname;
const faqMap = getFaqMap();
const redirectToEngine =
  !VALID_PATHS.includes(start_path.toLowerCase()) &&
  !faqMap[start_path.substring(1).toLocaleLowerCase()];

if (redirectToEngine) {
  // REDIRECT TO ENGINE //////////////////////////
  const redirectTo = "https://onelink.to" + start_path;
  window.location.replace(redirectTo);
} else {
  // NORMAL EXECUTION ////////////////////////////

  const Main = () => {
    let useDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    useDarkMode = false;
    const theme = getTheme(useDarkMode);

    return (
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalContext>
              <App />
            </GlobalContext>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    );
  };

  // CLEAN-UP DOM
  const rootElement = document.getElementById("root");
  rootElement.innerHTML = "";

  const legalElement = document.querySelector("body > div[role=presentation]");
  if (legalElement) legalElement.remove();

  ReactDOM.render(<Main />, rootElement);

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}
